import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { ImageUrl } from "../../helper/apiHelper";
const TopCategories = ({ topCategories }) => {
    
  return (
    <div className="">
      <div className="card">
        <div className="card-header">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
            <h6 className="mb-2 fw-bold text-lg mb-0">Top Categories</h6>
          </div>
        </div>
        <div className="card-body">
          {topCategories?.map((items, index) => {
            return (
              <div
                className="d-flex align-items-center justify-content-between gap-3 mb-24"
                key={index}
              >
                <div className="d-flex align-items-center gap-12">
                  <div className="w-40-px h-40-px radius-8 flex-shrink-0 bg-info-50 d-flex justify-content-center align-items-center">
                    <img

                      src={`${ImageUrl}/${items?.topCategory?.image_url}`}
                      alt=""
                      className=""
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="text-md mb-0 fw-normal">
                      {items?.topCategory?.name}
                    </h6>
                    <span className="text-sm text-secondary-light fw-normal">
                      {`${items.totalOrders} Orders`}
                    </span>
                  </div>
                </div>
                {/* <button
                  href="#"
                  className="w-24-px h-24-px bg-primary-50 text-primary-600 d-flex justify-content-center align-items-center text-lg bg-hover-primary-100 radius-4"
                > */}
                  {items?.route}
                {/* </button> */}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TopCategories;
